import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const DesktopFashion = dynamic(() => import('../../components/retail/fashion-apparel/DesktopFashion'), {
  loading: () => <Loading />,

});
const MobileFashion = dynamic(() => import('../../components/retail/fashion-apparel/MobileFashion'), {
  loading: () => <Loading />,

});


const fashionApparel = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>Fashion & Apparel POS Billing Software | Garment Software by QueueBuster</title>
        <link rel="canonical" href="https://queuebuster.co/retail/fashion-apparel-pos-billing-software" />
        <link href="https://queuebuster.co/retail/fashion-apparel-pos-billing-software" hrefLang="en-us" />
        <meta name="description" content="Upgrade your fashion and apparel store with QueueBuster's POS billing software. Our garment software streamlines billing, inventory management, and customer transactions, enhancing overall retail efficiency." />
        <meta property="og:title" content="Fashion & Apparel POS Billing Software | Garment Software by QueueBuster" />
        <meta property="og:description" content="Upgrade your fashion and apparel store with QueueBuster's POS billing software. Our garment software streamlines billing, inventory management, and customer transactions, enhancing overall retail efficiency." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/assets/outlet-og-img/fashion-apparel.jpg" />
        <meta property="og:url" content="https://queuebuster.co/retail/fashion-apparel-pos-billing-software" />

      </Head>
         <SchemaTags page="fashion-apparel-pos-billing-software" />
      {
        mobileView ? <MobileFashion /> : <DesktopFashion />
      }
    </>
  )
}

export default fashionApparel